import createModuleCrudDtoGenerator from "./create-module-crud-dto.generator";
import {NodePlopAPI} from "plop";
import nestNewProjectGenerator from "./new-project.generator";

export default function nestGenerators(plop: NodePlopAPI) {
    createModuleCrudDtoGenerator(plop);
    nestNewProjectGenerator(plop);
}
